import React from 'react'
import { Link } from 'react-router-dom';

export default function BeforeEmailVerification() {
  return (
    <>
    
        <div className='d-flex justify-content-center flex-column align-self-center px-3' style={{position:"fixed", margin: "30vh auto"}}>
        
            <h1 className="unbounded fw-bold" style={{ textTransform: 'uppercase'}}>
            Welcome To AlmostInvisible
            </h1>
            
            <h6 style={{fontSize:"20px"}}>
                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"></path></svg>
                <b>
                Check your email to verify your email address. You need to do this before you can Sign In.
                </b>
            </h6>

           
        </div>
    
    </>
  )
}
